import React from 'react';
import ReactDOM from 'react-dom';
import { createSlice, createAsyncThunk, getState } from "@reduxjs/toolkit";
import moment from "moment/moment";
import customerSlice from "../customer/customerSlice";
import ComplaintPositionSlice from "../complaintPosition/ComplaintPositionSlice";
import { combineReducers } from "@reduxjs/toolkit";
import { API_URL } from '../../api/ApiSettings';



const initialState = {
  complaintType: {
    name: 'NotSpecified',
    displayName: 'Nieokreślony',
    id: 0
  },
  createDate: moment(),
  erpStatus: '',
  isIssuing: false,
  isTermOfUseAccepted: false,
  isTermOfUseForWarrantyAccepted: false,
  isTermOfUseForSalesWarrantyAccepted: false,
  number: '',
  password: '',
};

export const getComplaint = createAsyncThunk('complaint/getCustomerComplaintTypes', async () => {
  const response = await fetch(`${API_URL}complaint/getCustomerComplaintTypes`);
  const data = await response.json();
  return data;
});

//getComplaintById
export const getComplaintById = createAsyncThunk(
  'complaint/getComplaintById',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}complaint/getComplaintById?complaintId=${id}`);
      const data = await response.json();
      return data;
    } catch (error) {
      if (error.response) {
        console.log(error);
        if(!error.response) throw error;
        return rejectWithValue(error.response.data);
      }
      throw error;
    }
  }
);

// export const issueComplaint = createAsyncThunk(
//   'complaint/issueData',
//   async (_, { getState }) => {
//     try {
//       const state = getState();
//       const positionsWithMergedFiles = state.complaintPositions.positions.map((item) => {
//         let newFiles = [];
//         if (Array.isArray(item.files)) {
//           newFiles = [...item.files];
//         }
//         if (Array.isArray(item.purchaseProve)) {
//           newFiles = newFiles.concat(item.purchaseProve);
//         }
//         return { ...item, files: newFiles };
//       });
    
//     // try {
//     //   const state = getState();
//     //   const positionsWithMergedFiles = state.complaintPositions.positions.map(
//     //     (item) => {
//     //       return { 
//     //         ...item, 
//     //         files: undefined, 
//     //         purchaseProve: undefined 
//     //       };
//     //     }
//     //   );
//       const customer = state.customer;
//       // const complaintToIssue = {
//       //   complaintHeader: state.complaint,
//       //   customer: customer,
//       //   complaintPositions: positionsWithMergedFiles,
//       //   targetCustomer: state.targetCustomer
//       // };
//       const complaintToIssue = {
//         complaintHeader: state.complaint,
//         customer: customer,
//         complaintPositions: positionsWithMergedFiles,
//         ...(state.customer.type.id === 2 && { targetCustomer: state.targetCustomer })
//       };
//       const response = await fetch(`${API_URL}complaint`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(complaintToIssue),
//       });
//       const result = await response.json();
//       return result;
//     } catch (error) {
//       console.log(error);
//     }
//   }
// );

export const issueComplaint = createAsyncThunk(
  'complaint/issueData',
  async (_, { getState, rejectWithValue }) => { 
    try {
      const state = getState();
      const positionsWithMergedFiles = state.complaintPositions.positions.map((item) => {
        let newFiles = [];
        if (Array.isArray(item.files)) {
          newFiles = [...item.files];
        }
        if (Array.isArray(item.purchaseProve)) {
          newFiles = newFiles.concat(item.purchaseProve);
        }
        return { ...item, files: newFiles };
      });

      const customer = state.customer;
      const complaintToIssue = {
        complaintHeader: state.complaint,
        customer: customer,
        complaintPositions: positionsWithMergedFiles,
        ...(state.customer.type.id === 2 && { targetCustomer: state.targetCustomer })
      };

      const response = await fetch(`${API_URL}complaint`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(complaintToIssue),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      return await response.json();
    } catch (error) {
      console.error("Błąd podczas zgłoszenia reklamacji:", error);
      return rejectWithValue(error.message || "Błąd sieci");
    }
  }
);

const complaintSlice = createSlice({
  name: 'complaint',
  initialState,
  reducers: {
    setComplaintType: (state, action) => {
      state.complaintType = action.payload;
    },
    setCustomerType: (state, action) =>{
      state.type = action.payload;
    },
    setCreatedDate: (state, action) => {
      state.createDate = action.payload;
    },
    setErpStatus: (state, action) => {
      state.erpStatus = action.payload;
    },
    setIssueComplaintRequest: (state) => {
      state.isIssuing = true;
    },
    setIssueComplaintFailure: (state) => {
      state.isIssuing = false;
    },
    setIssueComplaintSuccess: (state) => {
      const { isIssuing, complaint } = state;
      Object.assign(state, { ...initialState, isIssuing, complaint });
    },
    setIsTermOfUseAccepted: (state, action) => {
      state.isTermOfUseAccepted = action.payload;
    },
    setIsTermOfUseForWarrantyAccepted: (state, action) => {
      state.isTermOfUseForWarrantyAccepted = action.payload;
    },
    setIsTermOfUseForSalesWarrantyAccepted: (state, action) => {
      state.isTermOfUseForSalesWarrantyAccepted = action.payload;
    },
    setNumber: (state, action) => {
      state.number = action.payload;
    },
    setPassword: (state, action) => {
      state.password = action.payload;
    }
  },
  extraReducers: {
   
    [getComplaintById.fulfilled]: (state, action) => {
      state.id = action.payload;
    },
    // [issueComplaint.fulfilled]: (state, action) => {
    //   state.customer = action.payload;
    //   state.complaint = action.payload;
    //   state.complaintPosition = action.payload;
    // },
   [issueComplaint.pending]: (state) =>{
    state.isIssuing = true;
   },
   [issueComplaint.rejected]: (state) =>{
    state.isIssuing = false
   },
   [issueComplaint.fulfilled]: (state, action) =>{
    state.isIssuing = false;
    state.complaint = action.payload;
   }
  },
  
});

export const {
  setComplaintType,
  setCreatedDate,
  setErpStatus,
  setIssueComplaintRequest,
  setIssueComplaintFailure,
  setIssueComplaintSuccess,
  setIsTermOfUseAccepted,
  setIsTermOfUseForWarrantyAccepted,
  setIsTermOfUseForSalesWarrantyAccepted,
  setNumber,
  setPassword,
  
} = complaintSlice.actions;

export default complaintSlice.reducer;

// const rootReducer = combineReducers({
//   customer: customerSlice.reducer,
//   complaintPosition: ComplaintPositionSlice.reducer,
//   complaint: complaintSlice.reducer,
// });